import { z } from 'zod';
import { ACCOUNTING_TAGS, LEG_ROLES, OPERATION_CATEGORIES } from '../accounting/categories.js';
import { AccountNumSchema, IsoDateSchema } from './primitives.js';

const Category = z.enum(OPERATION_CATEGORIES);
const Role = z.enum(LEG_ROLES);
const Tag = z.enum(ACCOUNTING_TAGS);

export const AccountMappingRuleDtoSchema = z.object({
  id: z.number().int().positive(),
  category: Category,
  tag: Tag,
  role: Role,
  account: AccountNumSchema,
  priority: z.number().int().nonnegative(),
  version: z.number().int().positive(),
  effectiveFrom: IsoDateSchema,
  deletedAt: z.number().int().nonnegative().nullable(),
  createdAt: z.number().int().nonnegative(),
});

export const CreateAccountMappingRuleRequestSchema = AccountMappingRuleDtoSchema.pick({
  category: true,
  tag: true,
  role: true,
  account: true,
  priority: true,
  effectiveFrom: true,
});

export const DeleteAccountMappingRuleRequestSchema = z.object({ effectiveFrom: IsoDateSchema });

export type AccountMappingRuleVersionedDto = z.infer<typeof AccountMappingRuleDtoSchema>;
export type CreateAccountMappingRuleRequest = z.infer<typeof CreateAccountMappingRuleRequestSchema>;
export type DeleteAccountMappingRuleRequest = z.infer<typeof DeleteAccountMappingRuleRequestSchema>;
